/* eslint-disable arrow-body-style */
import http from "./utils";
import {
  keyMetricsListType,
  overviewOriginType,
} from '@/pages/opinion/types/performance';
import { mockPrefix, prefix } from './constants';
import axios from 'axios';
const CancelToken = axios.CancelToken;
export const getOverviewKeyMetrics: (
  payload: any,
) => Promise<keyMetricsListType> | keyMetricsListType = (payload) => {
  return http({
    url: `${prefix}/overview/key_metrics`,
    method: 'post',
    data: payload,
  }) as Promise<keyMetricsListType>;
};

export const getOverviewCountry: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/overview/country`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getOverviewRegion: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/overview/region`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getOverviewLanguage: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c) => {},
) => {
  const params: any = {
    url: `${prefix}/overview/language`,
    method: 'post',
    data: payload,
  };

  if (typeof cancelTokenFunc === 'function') {
    params.cancelToken = new CancelToken(cancelTokenFunc);
  }

  return http(params) as Promise<overviewOriginType>;
};

export const getOverviewChannel: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c) => {},
) => {
  const params: any = {
    url: `${prefix}/overview/channel`,
    method: 'post',
    data: payload,
  };

  if (typeof cancelTokenFunc === 'function') {
    params.cancelToken = new CancelToken(cancelTokenFunc);
  }

  return http(params) as Promise<overviewOriginType>;
};

export const getOverviewGameStore: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/overview/game_store`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getOverviewKeyword: (
  payload: any,
  cancelCallback?: any,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelCallback,
) => {
  let params: any = {
    url: `${prefix}/overview/keyword`,
    method: 'post',
    data: payload,
  };
  if (typeof cancelCallback === 'function') {
    params.cancelToken = new CancelToken(cancelCallback);
  }
  return http(params) as Promise<overviewOriginType>;
};

export const getOverviewTopic: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/overview/topic`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getOverviewCompetitor: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/overview/competitor`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getOverviewMentionsSentiment: (
  payload: any,
  cancelTokenFunc?: (c: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c: any) => {},
) => {
  return http({
    url: `${prefix}/overview/mentions_sentiment`,
    method: 'post',
    data: payload,
    errorHandler: true,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
};

export const getOverviewTopicTimeline: (
  payload: any,
  cancelCallback?: any,
) => Promise<any> = (payload) => {
  return http({
    url: `${prefix}/overview/topic_stats_timeline`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};
export const getOverviewKeywordTimeline: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/overview/keyword_stats_timeline`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getOverviewVersionTimeline: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/overview/batch_version_stats_timeline`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getOverviewDauRevDls: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/overview/dau_rev_dls`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getOverviewLifetimePcConsole: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/overview/lifetime_pc_console`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getOverviewTimeline: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/overview/timeline`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getOverviewPcConsoleTimeline: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/overview/lifetime_pc_console_timeline`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};
export const getOverviewPcConsoleLanguage: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/overview/lifetime_pc_console_language`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const downloadKeyMetrics: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/overview/key_metric_download`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getOverviewBatchTimeline: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/overview/batch_timeline`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getOverviewPcConsoleOperate: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/overview/pc_console_operate`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getOverviewTopicGptSummary: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/overview/topic_gpt_summary`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getSteamSupportLanguage: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c) => {},
) => {
  return http({
    url: `${prefix}/steam/language
`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
};

export const getSteamSupportLanguageTimeline: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c) => {},
) => {
  return http({
    url: `${prefix}/steam/language_timeline
`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
};
